<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent value="" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }} Contact Info</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert dense type="info" v-if="contactInfoMessage">
            {{ contactInfoMessage }}
          </v-alert>
          <v-container>
            <confirm-delete-in-modal
              v-if="showConfirmDelete"
              @confirmed="onConfirmDelete"
            ></confirm-delete-in-modal>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    required
                    :rules="[rules.required]"
                    v-model="contactTypeValue"
                    class="py-1"
                    dense
                    :items="contactTypes"
                    item-text="label"
                    item-value="value"
                    label="Type"
                    autocomplete="off"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="contactTypeValue && contactTypeValue.charAt(0) == 'p'"
                >
                  <v-text-field
                    id="contact-info-phone-number"
                    ref="contact-info-phone-number"
                    label="Phone Number"
                    v-model="phoneNumberValue"
                    class="py-1"
                    dense
                    required
                    :rules="[rules.required, rules.phone]"
                    persistent-hint
                    hint="e.g. (555) 555-1212"
                    v-mask="masks.phone"
                    v-on:keyup.enter="onSave"
                    autofocus
                    autocomplete="off"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="contactTypeValue && contactTypeValue.charAt(0) == 'e'"
                >
                  <v-text-field
                    id="contact-info-email-address"
                    ref="contact-info-email-address"
                    label="Email Address"
                    v-model="emailAddressValue"
                    class="py-1"
                    dense
                    required
                    :rules="[rules.email]"
                    persistent-hint
                    hint="e.g. myname@email.com"
                    v-mask="masks.nomask"
                    v-on:keyup.enter="onSave"
                    autofocus
                    autocomplete="off"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-switch
                v-if="contactTypeValue"
                v-model="receiveNotifications"
                class="py-1"
                dense
                :label="
                  receiveNotifications
                    ? 'Receive Notifications'
                    : 'No Notifications'
                "
              ></v-switch>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
            >Delete</v-btn
          >
          <v-btn color="primary tile" @click="onSave"
            >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";

const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `./ConfirmDeleteInModal.vue`
  );

export default {
  name: "ContactInfoFormModal",
  props: {
    contactInfoId: Number,
    contactInfoType: String,
    contactInfoDetails: String,
    contactInfoCustomerId: Number,
    contactInfoMessage: String,
    RerunReportCallback: Function,
    CallbackRecord: Object
  },
  directives: {
    mask
  },
  components: {
    ConfirmDeleteInModal
  },
  data: () => ({
    dialog: true,
    modalTitle: "Add",
    valid: true,
    showConfirmDelete: false,
    receiveNotifications: true,
    contactTypeValue: "phone-mobile",
    phoneNumberValue: null,
    emailAddressValue: null,
    contactTypes: [
      { header: "Phone", divider: "Phone" },
      { value: "phone-mobile", label: "Mobile Phone" },
      { value: "phone-home", label: "Home Phone" },
      { value: "phone-work", label: "Work Phone" },
      { value: "phone-other", label: "Other Phone" },
      { divider: "Email" },
      { header: "Email" },
      { value: "email-home", label: "Home Email" },
      { value: "emailemail-work", label: "Work Email" },
      { value: "email-other", label: "Other Email" }
    ],
    masks: MASKS,
    rules: VALIDATION_RULES
  }),
  computed: {
    isAddNew() {
      return this.contactInfoId == -1;
    },
    showDelete() {
      return !this.isAddNew && !this.showConfirmDelete;
    },
    currentContactInfo() {
      let contactInfo = this.$store.getters["entities/contactInfos/find"](
        this.contactInfoId
      );
      return contactInfo;
    },
    user() {
      return this.$store.getters["entities/users/find"](
        this.$store.getters["entities/settings/query"]().first().userId
      );
    }
  },
  created() {
    if (this.contactInfoType == "phone" && this.contactInfoDetails) {
      this.phoneNumberValue = this.contactInfoDetails;
    }
    if (
      this.contactInfoId != null &&
      this.contactInfoId > 0 &&
      this.currentContactInfo
    ) {
      this.modalTitle = "Update";
      this.contactTypeValue = [
        this.currentContactInfo.type,
        this.currentContactInfo.label
      ].join("-");
      this.receiveNotifications = this.currentContactInfo.receiveNotification;
      if (this.currentContactInfo.type == "phone") {
        this.phoneNumberValue = this.currentContactInfo.detail;
      } else if (this.currentContactInfo.type == "email") {
        this.emailAddressValue = this.currentContactInfo.detail;
      }
    }
  },
  methods: {
    onClose() {
      if (this.$parent.showAppointmentFormModal) {
        this.$root.$children[0].$refs[
          "customer-editor-modals"
        ].showContactInfoFormModal = false;
      } else {
        this.$root.$children[0].showCustomerEditorModals = false;
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        let detail = null;
        if (this.contactTypeValue.charAt(0) == "e") {
          detail = this.emailAddressValue;
        } else if (this.contactTypeValue.charAt(0) == "p") {
          detail = this.phoneNumberValue;
        }
        if (this.isAddNew) {
          const tempId = this.$uuidv4();
          const customerId =
            this.contactInfoCustomerId ||
            parseInt(this.user.currentCustomerId);
          this.$store.dispatch("entities/contactInfos/createContactInfo", {
            id: tempId,
            tempId: tempId,
            isDirty: true,
            accountId: this.user.accountId,
            customerId: customerId,
            type: this.contactTypeValue.split("-")[0],
            label: this.contactTypeValue.split("-")[1],
            detail: detail,
            receiveNotification: this.receiveNotifications
          });
          if (!(this.user.currentCustomerId > 0)) {
            // This only works for customer views
            if (
              this.$parent.ContactInfoType == "phone" &&
              this.$root.$children[0].$refs["router-view"].$refs[
                "history-center-rail"
              ]
            ) {
              let currentCall = this.$root.$children[0].$refs["router-view"]
                .$refs["history-center-rail"].currentSelectedCall[0];
              currentCall.customerId = customerId;
              this.$root.$children[0].$refs["router-view"].$refs[
                "calls-left-rail"
              ].clickCall(currentCall);
            // This is for merging of new contacts back into reports
            } else if (this.RerunReportCallback) {
              this.RerunReportCallback(this.CallbackRecord, customerId);
            }
          }
        } else if (this.contactInfoId > 0) {
          this.$store.dispatch("entities/contactInfos/updateContactInfo", {
            accountId: this.user.accountId,
            customerId:
              this.contactInfoCustomerId ||
              parseInt(this.user.currentCustomerId),
            id: this.contactInfoId,
            isDirty: true,
            type: this.contactTypeValue.split("-")[0],
            label: this.contactTypeValue.split("-")[1],
            detail: detail,
            receiveNotification: this.receiveNotifications
          });
        }
        this.onClose();
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/contactInfos/deleteContactInfo", {
        accountId: this.user.accountId,
        id: this.contactInfoId,
        isDirty: true
      });
      this.onClose();
    }
  }
};
</script>
<style scoped lang="stylus"></style>
